import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import DropdownSelect, { DropdownSelectProps } from '@/components/fields/DropdownSelect';
import countries from '@/utils/countries';

type CountryDropdownSelectProps = Omit<DropdownSelectProps, 'options'> & {
  allowedCountries?: string[];
};

const CountryDropdownSelect: FC<CountryDropdownSelectProps> = props => {
  const countryCodes = useMemo(() => Object.keys(countries.getAlpha3Codes()), []);
  const { i18n } = useTranslation();

  const countryOptions = useMemo(
    () =>
      (countryCodes || [])
        .map(code => ({
          label: countries.getName(code, i18n.language)!,
          value: code
        }))
        .filter(({ value }) => (props.allowedCountries ? props.allowedCountries?.includes(value) : true)),
    [countryCodes, i18n.language, props.allowedCountries]
  );

  return <DropdownSelect {...props} options={countryOptions} />;
};

export default CountryDropdownSelect;
